export default {
  defaultKpiName: 'Ventas',
  title: 'Datos del Modelo',
  save: 'Guardar',
  warning: 'Advertencia',
  cannotBeUndone: 'Esta acción no se puede deshacer. ¿Estás seguro?',
  abort: 'Cancelar',
  confirm: 'Confirmar',
  mediaChannels: 'Canales de Medios',
  kpis: 'KPIs'
}
